module.exports = __webpack_public_path__ + "static/media/launchpad_token_img.7f8aef24.png";